var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-magma',{staticClass:"u-pad-x-w1of16 u-pad-x-0@sm",attrs:{"content":_vm.content},on:{"page:ready":_vm.onPageReady}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3869b1f7","hasScoped":false,"buble":{"transforms":{}}}!./src/scripts/components/app-page-home/template.html
// module id = 455
// module chunks = 0